import {
    FETCH_TRAINING_READINESS_START,
    FETCH_TRAINING_READINESS_SUCCESS,
    FETCH_TRAINING_READINESS_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    trainingReadinessData: null,
    fetching: false,
    widgetsData: {},
    key: null,
    success: false,
    error: false,
    fetching: false
};

const trainingReadinessFetching = (state) => {
    return {
        ...state,
        trainingReadinessData: null,
        key: null,
        fetching: true
    };
};

const trainingReadinessSuccess = (success) => (state, action) => {
    if ('key' in action) {
        state.widgetsData[action.key] = action.data;
    }
    return {
        ...state,
        trainingReadinessData: success ? action.data : null,
        key: success ? action.key : null,
        fetching: false,
        success: success,
        error: !success
    };
};

export const isTrainingReadinessFetching = (state) => {
    return state.trainingReadiness.fetching;
};

export const isTrainingReadinessFetchSuccess = (state) => {
    return state.trainingReadiness.success;
};

export const isTrainingReadinessFetchError = (state) => {
    return state.trainingReadiness.error;
};

export const getTrainingReadinessData = (state) => {
    return state.trainingReadiness.trainingReadinessData;
};

export const getTrainingReadinessWidgetData = (state, key) => {
    return key in state.trainingReadiness.widgetsData ? state.trainingReadiness.widgetsData[key] : [];
};

const handlers = {
    [FETCH_TRAINING_READINESS_SUCCESS]: trainingReadinessSuccess(true),
    [FETCH_TRAINING_READINESS_START]: trainingReadinessFetching,
    [FETCH_TRAINING_READINESS_FAIL]: trainingReadinessSuccess(false)
};

export default function trainingReadiness(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    } else {
        return handler(state, action);
    }
}
